"use strict";
exports.__esModule = true;
exports.IdentityMatchStatus = exports.OnboardStatus = void 0;
var OnboardStatus;
(function (OnboardStatus) {
    OnboardStatus["ACTIVE"] = "active";
    OnboardStatus["ONBOARDING"] = "onboarding";
    OnboardStatus["UNKNOWN"] = "unknown";
})(OnboardStatus = exports.OnboardStatus || (exports.OnboardStatus = {}));
var IdentityMatchStatus;
(function (IdentityMatchStatus) {
    IdentityMatchStatus["MATCHING"] = "matching";
    IdentityMatchStatus["NO_MATCH"] = "no_match";
    IdentityMatchStatus["MATCHED"] = "matched";
})(IdentityMatchStatus = exports.IdentityMatchStatus || (exports.IdentityMatchStatus = {}));
